import { useTranslation } from 'react-i18next';
import { comparisonData } from '@/mocks/homeData';

export default function CompareSection() {
  const { t } = useTranslation();

  return (
    <section id="compare" className="w-full bg-background-100 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('compare_title')}
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              {t('compare_subtitle')}
            </p>
          </div>

          <div className="overflow-x-auto -mx-4 md:mx-0">
            <table className="w-full min-w-[700px] md:min-w-0 text-sm">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('compare_feature')}
                  </th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider bg-primary-50/50">
                    {t('compare_allchinabuy')}
                  </th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('compare_superbuy')}
                  </th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('compare_cssbuy')}
                  </th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('compare_sugargoo')}
                  </th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('compare_pandabuy')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-background-200/40 hover:bg-background-50/50 transition-colors"
                  >
                    <td className="py-3.5 px-4 font-medium text-foreground-900">
                      {row.feature}
                    </td>
                    <td className="py-3.5 px-4 text-center text-foreground-700 bg-primary-50/30 text-sm">
                      {row.allchinabuy}
                    </td>
                    <td className="py-3.5 px-4 text-center text-foreground-600 text-sm">
                      {row.superbuy}
                    </td>
                    <td className="py-3.5 px-4 text-center text-foreground-600 text-sm">
                      {row.cssbuy}
                    </td>
                    <td className="py-3.5 px-4 text-center text-foreground-600 text-sm">
                      {row.sugargoo}
                    </td>
                    <td className="py-3.5 px-4 text-center text-foreground-600 text-sm">
                      {row.pandabuy}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="mt-4 text-xs text-foreground-500 text-center italic">
            {t('compare_check')}
          </p>
        </div>
      </div>
    </section>
  );
}